import { Theme, createStyles } from '@material-ui/core';

export default ({ spacing }: Theme) =>
  createStyles({
    actionButton: {
      margin: `${spacing.unit}px 0`,
      maxHeight: 45,
    },
  });
